import * as angular from 'angular';
import { IUtilities } from '../../typings/services';
import { ClInputContainerController } from './ClInputContainerDirective';

/**
 * Simple wrapper for textarea, to help defer compilation of a cl-input-container until all elements are ready to be compiled.
 */

export class ClTextareaDirective implements angular.IDirective {
    public static $name: string = 'clTextarea';
    public restrict: string = 'E';

    public require: string = '^clInputContainer';

    public link = (scope: any, element: angular.IAugmentedJQuery,
                   attrs: angular.IAttributes, clInputContainerController: ClInputContainerController) => {
        /* Create a new input and copy over all attributes */
        let input = angular.element('<textarea></textarea>');
        this.utilities.copyAllAttributes(input, attrs);

        /* Add an aria-label if we didn't already have one */
        if (!input.attr('aria-label')) {
            input.attr('aria-label', input.attr('name'));
        }

        /* Attach validated input to controller so we can use it to $compile */
        clInputContainerController.input = input;

        /**
         * Remove the original element so that we can use the contents
         * of the input container that were not covered by a directive like this one
         */
        element.remove();

        /* Don't $compile here -- the $compile takes place in the ClInputContainerDirective */
    }

    constructor(
        private utilities: IUtilities
    ) {
    }

    public static Factory() {
        let directive = (utilities) => {
            return new ClTextareaDirective(utilities);
        };

        directive['$inject'] = ['utilities'];

        return directive;
    }
}
